module.exports = function() {
  return new Worker(__webpack_public_path__ + "e9fddadfe5fd8b7f77a7.worker.js");
};